import { render, staticRenderFns } from "./TopicPlusView.vue?vue&type=template&id=c596d2fe"
import script from "./TopicPlusView.vue?vue&type=script&lang=js"
export * from "./TopicPlusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports